import React from 'react';
import { QueryRenderer, graphql } from 'react-relay';
import RelayService from '../service/RelayService';
import Content from './Content';
import PropTypes from 'prop-types';

export default class ContentLoader extends React.Component {

  static propTypes = {
    tag: PropTypes.string,
  };

  render() {
    return (
      <QueryRenderer
        environment={RelayService.environment}
        query={graphql`
        query ContentLoaderQuery($tag: String) {
            content(tag: $tag)
        }
      `}
        variables={{
          tag: this.props.tag,
        }}
        render={({ error, props }) => {
          if (error) {
            return <div>{error.message}</div>;
          } else if (props) {
            return (
              <Content content={props.content} />
            );
          }
          return (
            <Content />
          );
        }}
      />
    )
  }

}